var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{key:_vm.id,class:_vm.colClass,attrs:{"cols":_vm.small ? _vm.cols : 2}},[_c('v-card',{key:_vm.id,class:_vm.cardClass,attrs:{"flat":_vm.small,"id":`${_vm.entityName}-card-${_vm.id}`}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }